// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/selectModal/selectModal.scss
// module id = 106
// module chunks = 0